<script lang="ts">
  import type {Comment, Poem} from '../types'
  import api from '../api/api'
  import {t} from '../i18n'

  export let poem: Poem
  export let onAdded: (c: Comment) => void
  let newComment = {} as Comment

  const postComment = async (e: Event) => {
    e.preventDefault()
    const response = await api.post<Comment>(`/poems/${poem.id}/comments`, {comment: newComment})
    newComment = {} as Comment
    onAdded(response)
  }
</script>

<form class="leave-comment-form" onsubmit={postComment}>
  <textarea placeholder={t.poem.comments.content_placeholder} bind:value={newComment.content} required/>

  <button class="post-comment-btn" type="submit">
    {t.poem.comments.submit}
  </button>
</form>
